import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../Sidebar";
const ImageTable1 = ({ allImageURLs, selectedImages, setSelectedImages }) => {
  const handleSelect = (imageUrl) => {
    // console.log("Selected image: ", imageUrl);
    setSelectedImages((prevSelected) =>
      prevSelected.includes(imageUrl)
        ? prevSelected.filter((img) => img !== imageUrl)
        : [...prevSelected, imageUrl]
    );
  };

  const displayedImages = allImageURLs.slice(0, 5);


  // const rows = [];

  // for (let i = 0; i < allImageURLs.length; i += 5) {
  //   const row = allImageURLs.slice(i, i + 5);

  //   // style={imageCellStyle}
  //   const columns = row.map((imageUrl, index) => (
  //     <td key={index}>
  //       <img src={imageUrl} alt={`Item ${index}`} className="news-img-media" />
  //     </td>
  //   ));

  //   rows.push(<tr key={i}>{columns}</tr>);
  // }

  return (
    <div className="image-grid">
      {displayedImages.map((imageUrl, index) => {
        const fileName = imageUrl.split("/").pop(); // Extract file name
        return (
          <div key={index} className="image-wrapper">
            <input
              type="checkbox"
              checked={selectedImages.includes(fileName)}
              onChange={() => handleSelect(fileName)}
            />
            <img
              src={imageUrl}
              alt={`Item ${index}`}
              className="news-img-media"
            />
          </div>
        );
      })}
    </div>
  );
};

export default function ImageTable() {
  const [imageUrls, setImageUrls] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const gerrit = async () => {
    const token = sessionStorage.getItem("token");
    const data = await fetch(`${process.env.REACT_APP_API_URL}/getCropImages`, {
      headers: {
        "x-access-token": token,
      },
    });
    const data1 = await data.json();
    setImageUrls(data1);
  };

  useEffect(() => {
    gerrit();
  }, []);

  const deleteImages = async () => {
    if (selectedImages.length === 0) {
      alert("No images selected for deletion.");
      return;
    }
    console.log("Selected images in deleted images function ", selectedImages);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/deleteCropImages`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileNames: selectedImages }),
      }
    );

    const result = await response.json();
    alert(result.msg);
    setSelectedImages([]);
    gerrit(); // Refresh images after deletion
  };
  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div id="bydrop">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>Image Gallery</h2>
          <div>
            <Link to="/image-input">
              <button
                className="btn btn-primary"
                style={{ marginRight: "10px" }}
              >
                Upload Images
              </button>
            </Link>
            {/* <button className="btn btn-danger" onClick={deleteImages}>
              Delete Selected Images
            </button> */}
          </div>
        </div>
        <ImageTable1
          allImageURLs={imageUrls}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
        />
      </div>
    </>
  );
}
